// Matriz de riesgo de autos (Carlos, 16-oct): score 0-100 = 35 % conductor + 65 % uso y entorno.
// Cada bloque es el promedio de sus variables; las red flags lo pasan a riesgo alto sin importar el score.
import m from '../datos/matriz-autos.json';

export const MATRIZ_AUTOS = m;
const ETIQUETA = { baja: 'Bajo', media: 'Medio', alta: 'Alto' };

// Preguntas del perfilamiento de autos, en el formato de PREGUNTAS (engine/perfil.js)
export const PREGUNTAS_MATRIZ_AUTOS = m.bloques.flatMap((b) => b.variables.map((v) => ({
  id: v.id, label: v.label, q: v.q, qu: v.qu, opts: Object.keys(v.puntos),
})));

export function perfilAutos(answers) {
  const bloques = m.bloques.map((b) => {
    const vars = b.variables.map((v) => ({ id: v.id, label: v.label, resp: answers[v.id], pts: v.puntos[answers[v.id]] }))
      .filter((v) => v.pts != null);
    const promedio = vars.length ? vars.reduce((s, v) => s + v.pts, 0) / vars.length : 0;
    return { id: b.id, nombre: b.nombre, peso: b.peso, vars, promedio, aporte: promedio * b.peso };
  });
  const score = Math.round(bloques.reduce((s, b) => s + b.aporte, 0));
  const flags = m.red_flags.filter((f) => Object.entries(f.si).every(([k, ops]) => ops.includes(answers[k])));
  const porScore = score >= m.umbrales.alta ? 'alta' : score >= m.umbrales.media ? 'media' : 'baja';
  const nivel = flags.length ? 'alta' : porScore;
  const completo = bloques.every((b) => b.vars.length);
  return { score, nivel, etiqueta: ETIQUETA[nivel], porScore, flags, bloques, completo, sus: susExacta(m.suscripcion[nivel], score) };
}

// Sesión #6: el deducible sale exacto según el puntaje (nunca un rango) cuando el nivel trae tramos
function susExacta(sus, score) {
  if (!sus.ded_exacto) return sus;
  const tramo = [...sus.ded_exacto].reverse().find((t) => score >= t.desde) || sus.ded_exacto[0];
  return { ...sus, ded_parcial: tramo.ded_parcial, ded_hurto: tramo.ded_hurto,
    ded_regla: `Deducible exacto por puntaje: ${sus.ded_exacto.map((t) => `desde ${t.desde} → ${t.ded_parcial.split(' (')[0]} parciales, ${t.ded_hurto} hurto`).join(' · ')}.` };
}

// Resumen de una línea para el panel del asesor
export const resumenPerfilAutos = (p) => `Riesgo ${p.etiqueta} · ${p.score}/100${p.flags.length ? ` · alerta: ${p.flags.map((f) => f.texto).join('; ')}` : ''}`;

const fmtMillones = (n) => `$${Math.round(n / 1e6).toLocaleString('es-CO')} M`;
const millonesDe = (txt) => {
  const s = String(txt || '');
  const mm = s.match(/([\d.]+)\s*(millones|M\b)/);
  if (mm) return Number(mm[1].replace(/\./g, '')) * 1e6;
  const n = Number(s.replace(/\D/g, ''));
  return n > 1e6 ? n : null;
};

// Cobertura de una póliza ajustada al perfil: tope de RC y deducibles del nivel de riesgo
export function ajustarCobertura(c, p) {
  if (!p || !p.completo) return c;
  const n = c.nombre.toLowerCase();
  if (n.includes('responsabilidad civil')) {
    const v = millonesDe(c.valor);
    return v && v > p.sus.rc ? { ...c, valor: fmtMillones(p.sus.rc), antes: c.valor, ajustado: true } : c;
  }
  // Riesgo bajo conserva los deducibles de la póliza; medio y alto los suben (nunca los bajan por perfil)
  if (p.nivel !== 'baja' && n.includes('parcial por daños')) return { ...c, deducible: p.sus.ded_parcial, antes: c.deducible, ajustado: true };
  if (p.nivel !== 'baja' && n.includes('hurto')) return { ...c, deducible: p.sus.ded_hurto, antes: c.deducible, ajustado: true };
  if (p.nivel === 'alta' && n.includes('reemplazo')) return { ...c, valor: p.sus.reemplazo, antes: c.valor, ajustado: true };
  return c;
}
